import { Component, Input, inject } from '@angular/core';
import { PictureV2Api, FileUploaderV2, FileUploadV2Module } from '@schenck/rotec-components';
import { ReportTemplateFieldDefinition, ReportTemplateFieldType } from 'src/dto/report-template';
import { LogoValidationService } from 'src/services';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'rc-template-toolbox-item',
  templateUrl: './template-toolbox-item.component.html',
  styleUrls: ['./template-toolbox-item.component.less'],
  imports: [FileUploadV2Module, TranslateDirective],
})
export class TemplateToolboxItemComponent {
  private readonly pictureApi = inject(PictureV2Api);
  public logoValidationService = inject(LogoValidationService);

  @Input() item: ReportTemplateFieldDefinition;

  ReportTemplateFieldType = ReportTemplateFieldType;
  fileUploader: FileUploaderV2 = new FileUploaderV2(this.pictureApi);

  selectLogo(logo: { id: string; file: File }) {
    this.item.value = logo?.id;
  }
}
